import type { CSSProperties, FC, PropsWithChildren } from "react";
import { cva } from "@stubhub/broadway-foundation/css";

const portalColRecipe = cva({
  base: {
    flexGrow: "0",
    flexShrink: "1",
    flexBasis: "auto",
  },
  variants: {
    spacing: {
      default: { paddingInlineEnd: "primitives.400" },
      increased: { paddingInlineEnd: "[36px]" },
    },
    minHeight: {
      constrained: { minHeight: "[250px]" },
      auto: {},
    },
    span: {
      "8": { flexBasis: "[calc(8 / 12 * 100%)]", maxWidth: "[calc(8 / 12 * 100%)]" },
      "4": { flexBasis: "[calc(4 / 12 * 100%)]", maxWidth: "[calc(4 / 12 * 100%)]" },
    },
  },
  defaultVariants: {
    spacing: "default",
    minHeight: "auto",
    span: "8",
  },
});

interface Props {
  increasedRightMargin?: boolean;
  setMinHeight?: boolean;
  minWidth?: number | undefined;
  flex?: CSSProperties["flex"];
  overflow?: CSSProperties["overflow"];
  boxSizing?: CSSProperties["boxSizing"];
  span?: "8" | "4";
}

const PortalCol: FC<PropsWithChildren<Props>> = ({
  children,
  increasedRightMargin,
  setMinHeight,
  minWidth,
  flex,
  overflow,
  boxSizing,
  span,
}) => (
  <div
    className={portalColRecipe({
      spacing: increasedRightMargin ? "increased" : "default",
      minHeight: setMinHeight ? "constrained" : "auto",
      span,
    })}
    style={{
      minWidth: minWidth ? `${String(minWidth)}px` : undefined,
      flex,
      overflow,
      boxSizing,
    }}
  >
    {children}
  </div>
);

export const PortalColLeft = (props: PropsWithChildren<Props>) => <PortalCol span="8" {...props} />;
export const PortalColRight = (props: PropsWithChildren<Props>) => <PortalCol span="4" {...props} />;
